/**
 * The statuses where a balance can genuinely still be owed: a DRAFT was never
 * issued, and PAID and VOIDED are settled or dead.
 */
const AWAITING_PAYMENT_STATUSES = new Set(['APPROVED', 'SENT']);
/**
 * The balance an invoice still owes, or `null` when it owes nothing a list
 * should show. Shared by the Bill invoices list and the invoice list PDF and
 * spreadsheet so the screen and the files agree on which rows carry one.
 *
 * A zero balance reads as nothing owed even while the status is still
 * APPROVED or SENT: the flip to PAID runs after the settlement that clears the
 * balance, not with it, so a fully settled invoice can sit on an open status.
 */
export function owedOutstandingMinorUnits(invoice) {
    return AWAITING_PAYMENT_STATUSES.has(invoice.status) && invoice.outstandingMinorUnits > 0 ? invoice.outstandingMinorUnits : null;
}
